import React from 'react';
import {
    Box, Button, CircularProgress, Dialog, DialogActions, DialogContent,
    DialogTitle, List, ListItem, ListItemText, ListItemSecondaryAction,
    Typography, Chip
} from '@material-ui/core';
import { WhatsAppPackageType } from 'api/whatsapp/types';
import { IApiState } from 'store/types';
import { apiStatus } from 'shared/constants/AppEnum';

interface RechargeDialogProps {
    open: boolean;
    onClose: () => void;
    packages: WhatsAppPackageType[];
    packagesApi: IApiState;
    rechargeApi: IApiState;
    onRecharge: (packageId: number) => void;
}

const RechargeDialog: React.FC<RechargeDialogProps> = ({
    open, onClose, packages, packagesApi, rechargeApi, onRecharge
}) => {
    const isLoading = rechargeApi.status === apiStatus.LOADING;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Select a Package to Recharge</DialogTitle>
            <DialogContent>
                {packagesApi.status === apiStatus.LOADING ? (
                    <Box display="flex" justifyContent="center" py={4}>
                        <CircularProgress />
                    </Box>
                ) : packages.length === 0 ? (
                    <Typography color="textSecondary">No packages available</Typography>
                ) : (
                    <List>
                        {packages.map((pkg) => (
                            <ListItem key={pkg.id} divider>
                                <ListItemText
                                    primary={
                                        <Box display="flex" alignItems="center">
                                            <Typography style={{ fontWeight: 600 }}>{pkg.name}</Typography>
                                            <Chip
                                                label={pkg.package_type_display}
                                                size="small"
                                                variant="outlined"
                                                style={{ marginLeft: 8 }}
                                            />
                                        </Box>
                                    }
                                    secondary={`${pkg.message_count} messages • ${pkg.description}`}
                                />
                                <ListItemSecondaryAction>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        disabled={isLoading}
                                        onClick={() => onRecharge(pkg.id)}
                                        startIcon={isLoading ? <CircularProgress size={14} /> : undefined}
                                    >
                                        ₹{pkg.price}
                                    </Button>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                    </List>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isLoading}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RechargeDialog;
